import { HighlightOff } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { FC } from "react";

interface IProductionPreviewProgressEndAdornmentProps {
  onAbort: () => void;
  isAbort: boolean;
}

export const ProductionPreviewProgressEndAdornment: FC<
  IProductionPreviewProgressEndAdornmentProps
> = ({ isAbort, onAbort }) => {
  if (isAbort) {
    return (
      <IconButton onClick={onAbort} size="small">
        <HighlightOff color="error" sx={{ width: 16, height: 16 }} />
      </IconButton>
    );
  }

  return null;
};
